import { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { DEFAULT_NOTE_IMG } from '../../../../utils/constant';

const PicCarousal = styled(Swiper)(({ theme }) => ({
  position: 'relative',
  width: '434px',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
  marginLeft: '1px',

  '& .swiper-button-prev::after,.swiper-button-next::after ': {
    color: 'rgba(255, 255, 255, 0.8)',
  },
  '& .swiper-pagination-bullet-active': {
    backgroundColor: '#D9D9D9A6',
  },
  [theme.breakpoints.down('750')]: {
    boxShadow: 'none',
  },
}));

const PictureSlide = styled(SwiperSlide)({});
const NotePic = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  [theme.breakpoints.down('750')]: {
    height: '90%',
  },
}));

const DefualtImg = styled('div')({});

const NotePictures = (props) => {
  const { notePics } = props;
  return (
    <>
      {notePics.length === 0 ? (
        <DefualtImg>
          <NotePic src={DEFAULT_NOTE_IMG} />
        </DefualtImg>
      ) : (
        <PicCarousal
          spaceBetween={30}
          navigation={true}
          pagination={{
            clickable: true,
          }}
          modules={[EffectFade, Navigation, Pagination]}
          style={{
            '--swiper-navigation-size': '25px',
          }}
        >
          {notePics.map((currentPic, key) => {
            return (
              <PictureSlide key={key}>
                <NotePic src={currentPic.url} alt={currentPic.name} />
              </PictureSlide>
            );
          })}
        </PicCarousal>
      )}
    </>
  );
};
export default NotePictures;
